import script from "./PlaylistThumbnail.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaylistThumbnail.vue?vue&type=script&setup=true&lang=js"

import "./PlaylistThumbnail.vue?vue&type=style&index=0&id=30ac2dae&lang=css"

const __exports__ = script;

export default __exports__